import { IconButton } from '@monorepo/shared/componentsV2/Button/IconButton';
import ExpandIcon from '@svg/expand.svg';
import React from 'react';
import styled from 'styled-components';
import { VisuallyHidden } from './VisuallyHidden';

const StyledIconButton = styled(IconButton)`
  font-size: 1rem;
`;

const RotatingExpandIcon = styled(ExpandIcon)<{ $expanded: boolean }>`
  color: ${({ theme }) => theme.colors.gray333};
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: rotate(${({ $expanded }) => ($expanded ? '0deg' : '180deg')});
`;

interface ExpandCollapseIconButtonProps {
  isExpanded: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export function ExpandCollapseIconButton({
  isExpanded,
  onClick,
  className,
}: ExpandCollapseIconButtonProps) {
  return (
    <StyledIconButton
      className={className}
      onClick={onClick}
      aria-expanded={isExpanded}
    >
      <RotatingExpandIcon $expanded={isExpanded} aria-hidden />
      <VisuallyHidden>{isExpanded ? 'Collapse' : 'Expand'}</VisuallyHidden>
    </StyledIconButton>
  );
}
